import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Layout from "../Layout/Layout";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import LoadingFallback from "../UI/LoadingFallback/LoadingFallback";
import { ROLE_PERMISSIONS_FLATTEN } from "../../helpers/permissionConstant";
import {
  DEVELOPMENT_ROUTE_PATH,
  ROUTE_PATH_NAME_BY_ID,
} from "../../helpers/permissionConstant";
import { MAGIC_MIRROR_ROUTE } from "../../features/magic-mirror/constants";
import {
  DASHBOARD_CONFIG_TABLE,
  DASHBOARD_TABLE_ROW_NAME,
} from "../../features/dashboard/helper/Dashboard";

function CustomRoutes() {
  const LoginCallback = lazy(
    () => import("../../features/auth/components/LoginCallback/LoginCallback")
  );

  const MyTasks = lazy(
    () => import("../../features/okr/my-tasks/MyTasks/MyTasks")
  );

  const SystemCategorylist = lazy(
    () =>
      import(
        "../../features/system-management/category-list/CategoryListManagement"
      )
  );

  const SystemDepartmentlist = lazy(
    () =>
      import(
        "../../features/system-management/department-list/DepartmentListManagement"
      )
  );

  const AsigneeList = lazy(
    () =>
      import(
        "../../features/system-management/handler-group/component/handlergroup-list/HanlderGroupManagement"
      )
  );
  const Qticket = lazy(
    () => import("../../features/system-management/qticket")
  );
  const QROrderManagement = lazy(
    () => import("../../features/system-management/qr-code-management/index")
  );
  const UserDetailPage = lazy(
    () => import("../../features/system-management/user/components/user-detail")
  );

  const OrganizationStructure = lazy(
    () => import("../../features/system-management/workspace/index")
  );

  const OrganizationStructureDetail = lazy(
    () =>
      import(
        "../../features/system-management/workspace/components/WorkspaceDetail/index"
      )
  );
  const Management3CX = lazy(
    () => import("../../features/system-management/management-3cx/index")
  );
  const SLAParameters = lazy(
    () => import("../../features/system-management/sla-parameters/index")
  );

  const Information = lazy(() => import("../../features/information/index"));
  // US_06 — Báo cáo cá nhân (Gương Thần)
  const PersonalReport = lazy(() => import("../../features/magic-mirror"));
  // US_05 — Tổng quan đơn vị (Gương Thần)
  const WorkspaceReport = lazy(() => import("../../features/magic-mirror/workspace"));
  const FilePreviewPage = lazy(
    () => import("../../features/file-preview/pages/FilePreviewPage")
  );

  const NoMatch = React.lazy(() => import("../../features/no-match/NoMatch"));
  const Unauthorized = lazy(() => import("../UI/Unauthorized/Unauthorized"));
  const Unauthenticated = lazy(
    () => import("../UI/Unauthenticated/Unauthenticated")
  );

  // Task Evaluation
  const TaskEvaluation = React.lazy(
    () => import("../../features/task-evaluation/TaskEvaluation")
  );
  // Main user evaluation
  const MainUserEvaluation = React.lazy(
    () => import("../../features/okr/main-user-evaluation/MainUserEvaluation")
  );
  //
  const ManagementTimeSheet = React.lazy(
    () => import("../../features/management-timesheet/ManagementTimeSheet")
  );

  const SystemUser = lazy(
    () => import("../../features/system-management/user/User")
  );

  const AccountInactive = React.lazy(
    () => import("../../features/no-match/AccountInactive")
  );

  const AccountNotWorkSpace = React.lazy(
    () => import("../../features/no-match/AccountNotWorkSpace")
  );

  //  Gprocess Dashboard
  // const GprocessDashboard = lazy(
  //   () => import("../../features/g-process/dashboard/Dashboard")
  // );
  // const GprocessDashboardContent = lazy(
  //   () => import("../../features/g-process/dashboard/content/Content")
  // );

  // Main dashboard
  const DashboardLayout: any = lazy(
    () => import("../../features/dashboard/Dashboard")
  );
  const DashboardContent = lazy(
    () => import("../../features/dashboard/views/content/DashboardContent")
  );
  const DashboardTask = lazy(
    () => import("../../features/dashboard/views/list-task/TaskList")
  );
  const GTicketTasks = lazy(
    () => import("../../features/dashboard/views/g-ticket-tasks/GTicketTask")
  );
  const TaskStatistics = lazy(
    () =>
      import("../../features/dashboard/views/task-statistics/TaskStatistics")
  );

  // Mobile detected
  const MobileDetectedView = lazy(
    () => import("../../features/mobile-view/index")
  );

  const GProcessRoutes = lazy(
    () => import("./route-groups/GProcessRoutes")
  );
  const GTicketRoutes = lazy(
    () => import("./route-groups/GTicketRoutes")
  );
  const GPerformanceRoutes = lazy(
    () => import("./route-groups/GPerformanceRoutes")
  );
  const OkrMyTargetRoute = lazy(
    () => import("./route-groups/OkrMyTargetRoute")
  );

  const { OKR, G_PMS } = ROLE_PERMISSIONS_FLATTEN;
  const MOBILE_DETECTED_PATH = "/mobile-detected";

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path={MOBILE_DETECTED_PATH} element={<MobileDetectedView />} />
        {/* authentication */}
        <Route
          path={ROUTE_PATH_NAME_BY_ID.UNAUTHENTICATED}
          element={
            <Layout>
              <Unauthenticated />
            </Layout>
          }
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID.UNAUTHORIZED}
          element={
            <Layout>
              <Unauthorized />
            </Layout>
          }
        />
        <Route path="/login/callback" element={<LoginCallback />} />
        {/* Main dashboard */}
        <Route
          index
          element={
            <Navigate to={ROUTE_PATH_NAME_BY_ID[G_PMS.MAIN_DASHBOARD]} />
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<DashboardContent />} />
          <Route
            path="/dashboard/tasks/:featureName"
            element={
              <DashboardTask />
            }
          />
          <Route
            path={
              DASHBOARD_CONFIG_TABLE[DASHBOARD_TABLE_ROW_NAME.G_TICKET].route
            }
            element={<GTicketTasks />}
          />
          <Route
            path="/dashboard/tasks-statistics/:featureName"
            element={<TaskStatistics />}
          />
        </Route>

        {/* Timesheet management */}
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.TIMESHEET_MANAGEMENT]}
          element={
            <PrivateRoute>
              <ManagementTimeSheet />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID[OKR.MY_TARGET]}
          element={<OkrMyTargetRoute />}
        />

        <Route
          path={ROUTE_PATH_NAME_BY_ID[OKR.MY_TASK]}
          element={
            <PrivateRoute>
              <MyTasks />
            </PrivateRoute>
          }
        />
        {/* US_06 — Báo cáo cá nhân (Gương Thần) */}
        {/* Gate menu/route bằng permission MAGIC_MIRROR = 156 (xem permissionFactory).
            Routing cá nhân/đơn vị do getReportCapability quyết định — dựa trên role
            report-GT (§1.1 /reports/me, lưu ở redux selectReportRole). */}
        <Route
          path={MAGIC_MIRROR_ROUTE.PERSONAL}
          element={
            <PrivateRoute>
              <Layout>
                <PersonalReport />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={MAGIC_MIRROR_ROUTE.EMPLOYEE}
          element={
            <PrivateRoute>
              <Layout>
                <PersonalReport />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${MAGIC_MIRROR_ROUTE.EMPLOYEE}/:userId`}
          element={
            <PrivateRoute>
              <Layout>
                <PersonalReport />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path={MAGIC_MIRROR_ROUTE.WORKSPACE}
          element={
            <PrivateRoute>
              <Layout>
                <WorkspaceReport />
              </Layout>
            </PrivateRoute>
          }
        />
        {/* Người dùng chính đánh giá nhiệm vụ */}
        <Route
          path={ROUTE_PATH_NAME_BY_ID[OKR.KEY_STAKEHOLDER_RATING]}
          element={
            <PrivateRoute>
              <MainUserEvaluation />
            </PrivateRoute>
          }
        />
        {/* Gticket */}
        <Route path="/gticket/*" element={<GTicketRoutes />} />
        {/* endGictket */}

        {/* Đánh giá nhiệm vụ */}
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.TASK_EVALUATION]}
          element={
            <PrivateRoute>
              <TaskEvaluation />
            </PrivateRoute>
          }
        />

        {/* Gprocess - MODULE */}
        {/* Dashboard Gprocess */}
        {/* <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PROCESS.DASHBOARD]}
          element={
            <PrivateRoute>
              <GprocessDashboard />
            </PrivateRoute>
          }
        >
          <Route index element={<GprocessDashboardContent />} />
          <Route path="*" element={<NoMatch />} />
        </Route> */}
        <Route path="/g-process/*" element={<GProcessRoutes />} />
        {/* END Gprocess - MODULE */}

        {/* G-Performance */}
        <Route path="/g-performance/*" element={<GPerformanceRoutes />} />

        {/* Quản trị hệ thống */}
        <Route
          path="system-management/user"
          element={
            <PrivateRoute>
              <SystemUser />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="system-management/category-list"
          element={<SystemCategorylist />}
        ></Route>
        <Route
          path="system-management/department-list"
          element={<SystemDepartmentlist />}
        ></Route>
        <Route
          path="system-management/assignee"
          element={<AsigneeList />}
        ></Route>
        <Route
          path="system-management/user-detail/:id/:mode?"
          element={
            <Layout>
              <UserDetailPage />
            </Layout>
          }
        ></Route>
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.QUICK_TICKET_MANAGEMENT]}
          element={<Qticket />}
        ></Route>
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.QR_ORDER_MANAGEMENT]}
          element={<QROrderManagement />}
        ></Route>
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.ORGANIZATIONAL_STRUCTURE]}
          element={
            <PrivateRoute>
              <OrganizationStructure />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.ORGANIZATIONAL_STRUCTURE_DETAIL]}
          element={<OrganizationStructureDetail />}
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.MANAGEMENT_3CX]}
          element={<Management3CX />}
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.SLA_PARAMETERS]}
          element={
            <PrivateRoute>
              <SLAParameters />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID[G_PMS.INFORMATION]}
          element={<Information />}
        />
        <Route
          path="/file-preview/:fileId"
          element={
            // <PrivateRoute>
              <FilePreviewPage />
            // </PrivateRoute>
          }
        />
        <Route
          path={ROUTE_PATH_NAME_BY_ID.ACCOUNT_INACTIVE}
          element={
            <Layout>
              <AccountInactive />
            </Layout>
          }
        />

        <Route
          path={ROUTE_PATH_NAME_BY_ID.ACCOUNT_NOT_WORKSPACE}
          element={<AccountNotWorkSpace />}
        />

        <Route
          path="*"
          element={
            <PrivateRoute>
              <NoMatch />
            </PrivateRoute>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default CustomRoutes;
